import ssc from './ssc';
// import xyrb from './xyrb';
// import pk10 from './pk10';
// import ks from './ks';

export default (type, data, Vue) => {
  if (type == 'ssc') {
    return ssc(data);
  }
  // if (type == 'xyrb') {
  //   return xyrb(data);
  // }
  // if (type == 'PK10' || type == 'nn') {
  //   return pk10(data);
  // }
  // if (type == 'ks') {
  //   return ks(data);
  // }
};



// WEBPACK FOOTER //
// ./src/pages/Trend/Xingtaizoushi/columns/index.js